import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { X } from "react-feather";
import Select from "react-select/creatable";
import { components } from "react-select";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { getApiUrl } from "../utils/baseUrl";
import { GLOBAL_ENUM } from "../core/dictionary/global";
import { getIntelUrl } from "../utils/intelUrl";
import { getCompanyComingFrom, generateTrackingObject } from "../core/global/global-country-functions";
import trackingEventDictionary from "../core/dictionary/tracking-event";
import { trademoTrackingEvents } from "../core/global/trademo-tracking";
import { useLocation } from "react-router-dom";
import { getSidebarCountData } from "../redux/Sidebar/sidebarCount.action";
import { useDispatch, useSelector } from "react-redux";
import { profileName as profileNameEnum } from "@utils/enum";
import { LOB_ENUM } from "@routes/intel/ProductOnboarding/utils";

const BOOKMARK_TYPES = [
  { label: "Your Buyer", value: "buyer" },
  { label: "Your Supplier", value: "supplier" },
  { label: "Your Competitor", value: "competitor" },
];

const intelAPIEndpoints = {
  saveFavouriteCompanies: getApiUrl("addFavouriteCompany"),
  usersAllFavouriteCompanyTags: getApiUrl("usersAllFavouriteCompanyTags"),
  mergeCompanies: getApiUrl("mergeCompanies"),
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
  getMergedCompanyAliasNames: getApiUrl("getMergedCompanyAliasNames"),
};

const AddFavModal = ({ profileType, show, handleClose, prospectData, type, tradeDirection, country, dataSource, clearSelectedColumns, modalType, analyticsCountryID, pathname, currentUserPlan, isRedirectProp, id, currentKeyViewTrendItem, setIsFavourite, onAddSuccess, defaultBookmarkType }) => {
  const [tagList, setTagList] = useState([]);
  const [value, setValue] = useState([]);
  const [companiesData, setCompaniesData] = useState(prospectData);
  const [aliasName, setAliasName] = useState("");
  const [isRedirect, setIsRedirect] = useState(false);
  const [companyId, setCompanyID] = useState("");
  const [mergedId, setMergedId] = useState("");
  const [bookmarkType, setBookmarkType] = useState("");
  const [bookmarkTypeError, setBookmarkTypeError] = useState(false);
  const { MERGE, UPDATE } = GLOBAL_ENUM;
  const { search: searchUrlParams } = useLocation();
  const dispatch = useDispatch();
  const profileName = new URLSearchParams(searchUrlParams).get("redirectingProfile") || new URLSearchParams(searchUrlParams).get("profileName");
  const { userData } = useSelector((state) => state.userDetails);
  const isImpExpPersona = userData?.line_of_business === LOB_ENUM.IMPORT || userData?.line_of_business === LOB_ENUM.EXPORT || userData?.line_of_business === LOB_ENUM.EXPORT_AND_IMPORT;

  useEffect(() => {
    if (show) {
      setBookmarkType(defaultBookmarkType || "");
      setBookmarkTypeError(false);

      let url = intelAPIEndpoints.usersAllFavouriteCompanyTags + "?type=" + profileType;
      if (id) {
        url += "&company_id=" + id;
      }
      axios.get(url).then(({ data }) => {
        if (data?.favouriteCompanyTags?.length) {
          let companyTags = data.favouriteCompanyTags.map((item) => ({ label: item, value: item }));
          let selectedTags = data.selectedTagList.map((item) => ({ label: item, value: item }));
          setTagList(companyTags);
          setValue(selectedTags);
        }
      });
    }
  }, [show, prospectData, modalType]);

  const getRequestObj = () => {
    const requestObj = [];
    companiesData.map((item) => {
      if (!!item && (!!item.key || item.company_name || !!item.shipper_company_id || !!item.consignee_company_id || !!item.company_id || !!item.hashed_id || item.redirection_id || item.elastic_data_id || !!item.comp_id)) {
        let tempObj = {};

        tempObj.company_id = item?.hashed_id || item?.company_id || item?.shipper_company_id || item?.consignee_company_id || item?.redirection_id || item?.comp_id;
        tempObj.isAppendTags = true;
        tempObj.is_merged = false;
        tempObj.company_name = item?.company_name ? item.company_name : item.key;
        tempObj.type = profileType;
        tempObj.company_user_pov = bookmarkType;
        if (tradeDirection || item.trade_direction) tempObj.trade_direction = tradeDirection ? tradeDirection : item.trade_direction; // this helps in identifying import or export in dashboard, expected value import or export
        if (country || item.company_country) tempObj.company_country = country ? country : item.company_country; // this helps in identifying company profile redirection in dashboard, expected value country name in small letters
        if (dataSource || item.data_source) tempObj.data_source = dataSource ? dataSource : item.data_source;
        if (!!value && value.length) tempObj.tags = value.map((item) => item.value);
        if (type) tempObj.company_type = type.toUpperCase() === "EXPORTER" || type.toUpperCase() === "EXPORT" ? "E" : "I";
        if (item.is_merged) tempObj.is_merged = true;
        if (Array.isArray(tempObj.company_id) && tempObj.company_id.length === 1) {
          tempObj.company_id = tempObj.company_id[0];
        }
        if (profileName) {
          tempObj.redirectionKey = profileName;
        }
        if (currentKeyViewTrendItem && currentKeyViewTrendItem?.profileType) {
          tempObj.redirectionKey = currentKeyViewTrendItem?.profileType;
        }
        if (type?.toLowerCase() === "logistics" && item?.company_type?.length > 0) {
          tempObj.redirectionKey = item?.company_type?.join(",");
        }
        if (tempObj?.company_id) {
          requestObj.push(tempObj);
        }
      }
    });
    return requestObj;
  };

  const saveProspectExporter = () => {
    if (isImpExpPersona && profileType === "company" && modalType !== UPDATE && modalType !== MERGE) {
      if (!bookmarkType) {
        setBookmarkTypeError(true);
        return;
      }
    }

    if (!!analyticsCountryID && !!pathname && !!currentUserPlan) {
      if (type.toLowerCase() === "importer") {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripAddToFavouritesConfirm, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
      } else if (type.toLowerCase() === "exporter") {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripAddToFavouritesConfirm, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
      } else {
        checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripAddToFavouritesConfirm, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
      }
    }
    if (!!companiesData && companiesData.length !== 0) {
      let requestObj = getRequestObj();
      const filteredApiUrl = intelAPIEndpoints.saveFavouriteCompanies;
      axios.post(filteredApiUrl, requestObj).then(
        (res) => {
          if (!!res && !!res.data) {
            if (res.data.status === "success") {
              onAddSuccess?.({ bookmarkType });
              if (modalType === UPDATE) {
                toast.success("Tags updated successfully");
              } else {
                toast.success(res.data.message);
              }
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
          if (clearSelectedColumns) {
            clearSelectedColumns();
          }
          dispatch(getSidebarCountData());
          setIsFavourite?.(true);
          handleClose();
        },
        () => {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      );
    } else {
      toast.error("Please select atleast one " + type.toLowerCase() + ".");
    }
  };

  const removeCompanyHandler = (index) => {
    let companiesDataClone = JSON.parse(JSON.stringify(companiesData));
    companiesDataClone.splice(index, 1);
    setCompaniesData(companiesDataClone);
  };

  const mergeCompanyHandler = () => {
    let val = aliasName.trim();
    if (!val) {
      return toast.error("Please enter alias name");
    }
    let tempObj = {};

    tempObj.company_name = aliasName;
    tempObj.companyList = companiesData.map((item) => ({
      company_id: item.company_id ? item.company_id : item.hashed_id ? item.hashed_id : item.shipper_company_id ? item.shipper_company_id : item.consignee_company_id,
      company_name: item.key ? item.key : item.company_name,
    }));
    if (type) tempObj.company_type = type.toUpperCase() === "EXPORTER" || type.toUpperCase() === "EXPORT" ? "E" : "I";
    if (tradeDirection) tempObj.trade_direction = tradeDirection ? tradeDirection : ""; // this helps in identifying import or export in dashboard, expected value import or export
    if (country) tempObj.company_country = country ? country : ""; // this helps in identifying company profile redirection in dashboard, expected value country name in small letters
    if (dataSource) tempObj.data_source = dataSource ? dataSource : "";
    if (!!value && value.length) tempObj.tags = value.map((item) => item.value);
    tempObj.type = profileType;
    const filteredApiUrl = intelAPIEndpoints.mergeCompanies;
    axios
      .post(filteredApiUrl, tempObj)
      .then(
        (res) => {
          if (!!res && !!res.data) {
            if (res.data.status === "success") {
              toast.success(res.data.message);
              setCompanyID(res.data.data.company_id);
              setMergedId(res.data.data.mergedID);
              setIsRedirect(true);
              dispatch(getSidebarCountData());
            } else {
              toast.error(res.data.message);
            }
          } else {
            toast.error("Something went wrong. Please try again after sometime!!!");
          }
          if (clearSelectedColumns) {
            clearSelectedColumns();
          }
        },
        () => {
          toast.error("Something went wrong. Please try again after sometime!!!");
        }
      )
      .catch((err) => {
        toast.error(err.response.message);
      });
  };

  const submitHandler = () => {
    if (modalType === MERGE) {
      if (aliasName) {
        mergeCompanyHandler();
      } else {
        toast.error("Please enter alias name");
      }
    } else {
      saveProspectExporter();
    }
  };

  const getSlugHandler = () => {
    const params = {
      companyId: companyId,
      isMerged: true,
      mergedID: mergedId,
    };
    axios.get(intelAPIEndpoints.getCompanySlug, { params }).then((res) => {
      if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
        if (!!res.data.data && !!res.data.data.companySlug && res.data.data.companySlug !== "") {
          let url = "";
          dataSource = dataSource === "united kingdom" ? "uk" : dataSource;
          url = getIntelUrl() + res.data.data.companySlug + "/" + res.data.data.aliasCompanyId + `?country=${dataSource.toLowerCase()}&type=${tradeDirection}&comingFrom=` + getCompanyComingFrom(tradeDirection) + `&isMerged=true&mergedID=${mergedId}&tab=${type[0]}`;
          if (!!url && url !== "") {
            window.open(url, "_blank");
          } else {
            toast.error("Something went wrong. Please try again later !!!");
          }
        } else {
          toast.error("No company profile found in our system !!!");
        }
      } else {
        toast.error("No company profile found in our system !!!");
      }
    });
  };

  const checkPendoEventForCompanyRedirection = (event) => {
    let tempEvent;
    for (let [key, value] of Object.entries(trackingEventDictionary)) {
      if (event && key && value === event) {
        tempEvent = key;
      }
    }
    tempEvent = "companyRedirection" + tempEvent[0].toUpperCase() + tempEvent.slice(1);
    if (tempEvent && trackingEventDictionary && trackingEventDictionary[tempEvent] && isRedirectProp) {
      trademoTrackingEvents(trackingEventDictionary[tempEvent], generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    } else {
      trademoTrackingEvents(event, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    }
  };

  const handleBookmarkTypeChange = (val) => {
    setBookmarkType(val);
    if (val) setBookmarkTypeError(false);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal
        centered
        size="xl"
        show={show}
        backdrop="static"
        onHide={() => {
          handleClose();
        }}>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === MERGE ? "Merge Companies" : modalType === UPDATE ? "Update Tags" : `Add ${profileNameEnum[profileType] ? profileNameEnum[profileType] : "companies"}${profileNameEnum[profileType] === profileNameEnum.logistics ? " Companies" : ""} to Bookmarks`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={!isRedirect ? "py-0 add_fav_modal_body" : "d-flex justify-content-center align-items-center"}>
          {!isRedirect ? (
            <div className="row add_fav_modal_row">
              <div className="col-6 tw-p-3 tw-space-y-2 tw-max-h-[500px] tw-overflow-y-auto">
                <p className="tw-text-sm tw-font-medium tw-text-gray-900">Adding {companiesData ? companiesData.length : ""} companies </p>
                <div className="tw-space-y-1.5 tw-text-gray-900">
                  {companiesData.map((item, index) => (
                    <div key={item.key} className="tw-flex tw-items-center tw-border tw-border-gray-200 tw-rounded-full tw-gap-2 tw-text-sm tw-px-3 tw-py-1 tw-w-fit">
                      <p data-for={"index"} data-tip={item.key ? item.key : item.company_name} className="tw-m-0">
                        {item.key ? item.key.slice(0, 40) : item.company_name ? item.company_name.slice(0, 40) : ""}
                        {!!item.key && item.key.length > 40 ? "..." : !!item.company_name && item.company_name.length > 40 ? "..." : ""}
                      </p>
                      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={"index"} />
                      {modalType === MERGE ? companiesData.length > 2 ? <X size="14" className="tw-cursor-pointer" onClick={() => removeCompanyHandler(index)} /> : "" : companiesData.length > 1 ? <X size="14" className="tw-cursor-pointer" onClick={() => removeCompanyHandler(index)} /> : ""}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-6 py-3">
                {modalType === MERGE ? (
                  <div className="mb-4">
                    <p className="add_to_fav_input_heading">Add Alias for Merged Company Profile *</p>
                    <input className="merge_company_input" onChange={(e) => setAliasName(e.target.value)} placeholder="Provide an alias to the merged profile" />
                  </div>
                ) : null}

                {isImpExpPersona && profileType === "company" && modalType !== MERGE && modalType !== UPDATE && (
                  <div className="tw-mb-4">
                    <p className="tw-text-sm tw-font-medium tw-text-gray-900 tw-mb-2">
                      Bookmark Type <span className="tw-text-red-500 tw-text-sm">*</span>
                    </p>
                    <div className="tw-flex tw-flex-wrap tw-gap-2">
                      {BOOKMARK_TYPES.map((bt) => (
                        <label key={bt.value} onClick={() => handleBookmarkTypeChange(bt.value)} className={["tw-flex tw-items-center tw-gap-1.5 tw-px-3.5 tw-py-1.5 tw-rounded-md tw-border tw-cursor-pointer tw-text-sm tw-transition-all tw-duration-150 tw-select-none tw-mr-2 tw-mb-1", bookmarkType === bt.value ? "tw-border-[#6F08F1] tw-bg-[#F3EBFF] tw-text-[#6F08F1] tw-font-medium" : bookmarkTypeError ? "tw-border-red-500 tw-bg-white tw-text-gray-700 tw-font-normal" : "tw-border-gray-300 tw-bg-white tw-text-gray-700 tw-font-normal"].join(" ")}>
                          <input type="radio" name="bookmarkType" value={bt.value} checked={bookmarkType === bt.value} onChange={() => handleBookmarkTypeChange(bt.value)} className="tw-accent-[#6F08F1] tw-mr-1" />
                          {bt.label}
                        </label>
                      ))}
                    </div>
                    {bookmarkTypeError && <p className="tw-text-red-500 tw-text-[13px] tw-mt-1.5 tw-mb-0">Bookmark Type is required</p>}
                  </div>
                )}

                <p className="tw-text-sm tw-font-medium tw-text-gray-900 tw-mb-2">Add customized tags for easy access in the dashboard</p>
                <Select
                  options={tagList}
                  isMulti
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                    NoOptionsMessage: (props) => (
                      <components.NoOptionsMessage {...props}>
                        <p className="text-left mb-0">Type to enter tags</p>
                      </components.NoOptionsMessage>
                    ),
                  }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      border: state.isFocused ? " 1px solid #6F08F1" : "",
                      "&:hover": {
                        border: "1px solid #6F08F1",
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 1000,
                    }),
                    multiValue: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "100px",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }),
                  }}
                  value={value}
                  isOptionDisabled={() => !!value && value.length >= 10}
                  onChange={(e) => {
                    setValue(e);
                  }}
                  placeholder={"You can add upto 10 tags"}
                  formatCreateLabel={(input) => (
                    <>
                      Select <b>'{input}'</b> or Press Tab to add new tag
                    </>
                  )}
                />
                <div className="tw-mt-4 tw-text-sm tw-font-medium tw-text-gray-600">
                  <p className="tw-m-0">Instructions:</p>
                  <div>
                    <p className="tw-m-0 tw-mt-2">1. You can provide customized tags to filter down the list of your bookmark companies in the bookmarks section of your dashboard.</p>
                    <p className="tw-m-0 tw-mt-2">2. Some of the examples tags are: Product: Chemicals, Company Industry: Steel Manufacturing, etc.</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-50 text-center mt-3">
              <img className="mb-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1676966285/intel/icons/checkbox-circle-fill_djxwp3.svg" />
              <div>We have successfully merged {companiesData.length} companies. You can acccess it from your bookmarks in the Dashboard</div>
              <button className="btn btn-primary trademo-new-btn mt-5" onClick={getSlugHandler}>
                Open Merged Company Profile
              </button>
            </div>
          )}
        </Modal.Body>
        {!isRedirect ? (
          <Modal.Footer>
            <button className="fav-modal-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button className="btn btn-primary trademo-new-btn" onClick={submitHandler}>
              {modalType === MERGE ? "Merge Companies" : modalType === UPDATE ? "Update Tags" : "Bookmark"}
            </button>
          </Modal.Footer>
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
};

export default AddFavModal;
